import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jira: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.jira',
		defaultMessage: 'Jira status',
		description: 'Header of the Jira column in the status mapping table',
	},
	noStatus: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.no-status',
		defaultMessage: 'There are no status in your selected list.',
		description: 'Message shown when there are no status to map',
	},
	statusHeader: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-header',
		defaultMessage: 'status',
		description: 'Header of the third party status column in the status mapping table',
	},
});
